import { v4 as uuidv4 } from 'uuid';

/**
 * Display form field errors
 * 
 * @param {HTMLFormElement} formEl - Form HTML element
 * @param {object} data - Field error key-value pairs (fieldName: message)
 * 
 * @returns {Promise}
 */
export const addFieldErrors = (formEl, data) => {
  return new Promise((resolve) => {
    for (const [fieldName, message] of Object.entries(data)) {
      const inputEl = formEl.querySelector(`[name="${fieldName}"]`);
      if (inputEl) {
        const parentEl = inputEl.closest('[data-form-field]');
        const isChoices = (parentEl.querySelector('.choices')) ? true : false;
        const errorId = `_${uuidv4()}`;
        const inputId = inputEl.getAttribute('id') || null;
        if (inputId) {
          inputEl.setAttribute('aria-describedby', errorId);
        }
        if (isChoices) {
          parentEl.querySelector('.choices').classList.add('is-invalid');
        } else {
          inputEl.classList.add('is-invalid');
        }
        const errorHtml = `<div class="invalid-feedback" id="${errorId}">${message}</div>`;
        parentEl.insertAdjacentHTML('beforeend', errorHtml);
      }
    }
    resolve();
  });
};

/**
 * Clear all form field errors
 * 
 * @param {HTMLFormElement} formEl - Form HTML element
 * 
 * @returns {void}
 */
export const clearFieldErrors = (formEl) => {
  Array.from(formEl.querySelectorAll('[data-form-field]')).forEach(fieldEl => {
    const invalidEl = fieldEl.querySelector('.is-invalid');
    const errorEl = fieldEl.querySelector('.invalid-feedback');
    if (invalidEl) {
      invalidEl.classList.remove('is-invalid');
      if (invalidEl.hasAttribute('aria-describedby')) {
        invalidEl.removeAttribute('aria-describedby');
      }
    }
    if (errorEl) {
      errorEl.parentNode.removeChild(errorEl);
    }
  });
};
